"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clone = _interopRequireDefault(require("lodash/clone"));

var _flatten = _interopRequireDefault(require("lodash/flatten"));

var _max = _interopRequireDefault(require("lodash/max"));

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _MonthByWeekChart = _interopRequireDefault(require("./MonthByWeekChart"));

var _CustomerYAxis = _interopRequireDefault(require("./CustomerYAxis"));

var _Styles = require("./Styles");

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledContainer = _styled["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  overflow-x: scroll;\n\n  > div:nth-of-type(2) {\n    margin-left: 80px;\n  }\n\n  &::-webkit-scrollbar {\n    -webkit-appearance: none;\n    border-radius: 8px;\n    background-color: #f2f2f2;\n  }\n\n  &::-webkit-scrollbar:vertical {\n    width: 0px;\n  }\n\n  &::-webkit-scrollbar:horizontal {\n    height: 9px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    border-radius: 8px;\n    background-color: #c4c4c4;\n  }\n"])));

var MonthByWeekChartContainer = function MonthByWeekChartContainer(_ref) {
  var children = _ref.children,
      ptoDateISO = _ref.ptoDateISO,
      siteProductionMonthsByWeek = _ref.siteProductionMonthsByWeek,
      timeZone = _ref.timeZone;
  var readingDictionary = siteProductionMonthsByWeek.reduce(function (dictionary, coordinate) {
    dictionary[coordinate.x] = coordinate.y;
    return dictionary;
  }, {});
  var hasNoData = Object.keys(readingDictionary).length === 0;
  var maxValue = (0, _max["default"])((0, _flatten["default"])((0, _clone["default"])(siteProductionMonthsByWeek)).map(function (c) {
    return c.y;
  }));
  var roundedMaxValue = Math.max(Math.ceil(maxValue / 5) * 5, 5);
  return /*#__PURE__*/_react["default"].createElement(StyledContainer, null, /*#__PURE__*/_react["default"].createElement(_CustomerYAxis["default"], {
    handleTickFormat: function handleTickFormat(tick) {
      return tick;
    },
    roundedMaxValue: roundedMaxValue,
    tickValues: [0, roundedMaxValue],
    yAxisLabel: "kWh"
  }), siteProductionMonthsByWeek.map(function (month) {
    return /*#__PURE__*/_react["default"].createElement(_MonthByWeekChart["default"], {
      key: month[0].x,
      ptoDateISO: ptoDateISO,
      roundedMaxValue: roundedMaxValue,
      siteProductionWeeklyReadings: month,
      timeZone: timeZone,
      renderHint: function renderHint(reading) {
        return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, reading && /*#__PURE__*/_react["default"].createElement(_Styles.HintValue, null, "".concat(parseFloat(reading).toFixed(2), " kWh")));
      }
    });
  }), hasNoData && children && /*#__PURE__*/_react["default"].createElement(_Styles.FillAvailableSpace, null, children));
};

MonthByWeekChartContainer.propTypes = {
  children: _propTypes["default"].node.isRequired,
  ptoDateISO: _propTypes["default"].string.isRequired,
  siteProductionMonthsByWeek: _propTypes["default"].arrayOf(_propTypes["default"].arrayOf(_propTypes["default"].shape({}))),
  timeZone: _propTypes["default"].string.isRequired
};
MonthByWeekChartContainer.defaultProps = {
  siteProductionMonthsByWeek: []
};
var _default = MonthByWeekChartContainer;
exports["default"] = _default;